import styled from 'styled-components'

// TODO: Remove hardcoded colors.
export const HighlightedText = styled.div`
  background: -webkit-linear-gradient(45deg, #ff21da, #c188ff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: fit-content;
`
